import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  width: 600px;
  padding: 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  box-sizing: border-box;

  border-radius: 16px;
  background: var(--alias-color-background-normal-normal);
`;

export const TitleContainer = styled.div`
  display: flex;
  padding-bottom: 20px;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

export const TabBarContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid var(--alias-color-line-normal);

  display: flex;
  padding: 0px 20px;
  align-items: flex-end;
  gap: 20px;
  flex: 1 0 0;
  box-sizing: border-box;
  height: 40px;
`;

export const TabLabel = styled.div<{ selected: boolean }>`
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  height: 40px;
  border-bottom: ${(props) => (props.selected ? "2px solid var(--alias-color-primary-normal)" : "none")};
  cursor: pointer;
`;

export const Line = styled.div`
  height: 1px;
  width: 100%;
  background: var(--alias-color-line-strong);
  align-self: stretch;
`;

export const CancelBtnContainer = styled.div`
  display: flex;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

export const TabContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const TabContentLabel = styled.div`
  display: flex;
  padding: 0px 20px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

export const DomainListContainer = styled.div`
  display: flex;
  width: 520px;
  height: 240px;
  max-height: 240px;
  padding: 16px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  box-sizing: border-box;
  overflow-y: auto;

  border-radius: 12px;
  border: 1px solid var(--alias-color-line-strong);
  background: var(--alias-color-background-normal-alternative);
`;
